// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"350":"72a30a16","443":"ad7f724d"}[chunkId] || chunkId) + "." + {"350":"504ef3eb7cc855e0","443":"f0eedb744b308050","483":"8d4724b059395f56","856":"46e298b1bff22bc8"}[chunkId] + ".js";
};